import { Injectable } from '@angular/core';
import { storeProjectLogo } from '@app/utils/project-logo.util';
import { environment } from '@environments/environment';
import { ProjectService } from '../project/project.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ThemesService {

  constructor(
    private projectService: ProjectService,
    private authService: AuthService
  ) {}

  async loadTheme(): Promise<void> {
    try {
      await new Promise((resolve) => {
        const projectId = this.authService.projectId;
        const path = `themes/${projectId}/theme.css`;
        const encodedPath = encodeURIComponent(path);
        const cssUrl = `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.bucket}/o/${encodedPath}?alt=media`+`&v=${new Date().getTime()}`;

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssUrl;
        link.onload = () => resolve(void 0);
        // Never block app bootstrap if custom theme is missing.
        link.onerror = () => resolve(void 0);

        document.head.appendChild(link);
      });
    } catch {
      // Do not fail app startup for optional branding assets.
    }
  }

  async loadLogo(): Promise<void> {
    try {
      const timeout = new Promise<null>((resolve) => setTimeout(() => resolve(null), 8000));
      const project = await Promise.race([
        this.projectService.getProjectById(this.authService.projectId),
        timeout,
      ]);
      if (project) {
        storeProjectLogo(project.logo);
      }
    } catch {
      // Keep startup resilient for public routes (portal/sign-contract) without project context.
    }
  }
}
